import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { Subject, takeUntil } from 'rxjs';
//import { Config } from "./../../../../helpers/config.helper"; // declare const config: any;
import { MenuAssist } from "./../../../../helpers/menu-assist.helper"; // declare const Helpers: any;
import { Menu } from "./../../../../helpers/menu.helper"; // declare const Menu: any;

class SidebarItem {
  constructor(id: number, label: string, icon: string, route: string | null, childItems: SidebarItem[] = [], iconColor: string = null, showChild: boolean = false,moduleKey: string = '', allowedRoles: string[] = []) {
    this.id = id;
    this.label = label;
    this.icon = icon;
    this.iconColor = iconColor;
    this.route = route;
    this.showChild = showChild;
    this.childItems = childItems;
    this.moduleKey = moduleKey;
    this.allowedRoles = allowedRoles;
  }
  id: number = 0;
  label: string = '';
  icon: string = '';
  iconColor: string = '';
  route: string | null = '';
  showChild: boolean = false;
  isActive: boolean = false;
  isOpen: boolean = false;
  childItems: SidebarItem[] = [];
  moduleKey: string = '';
  allowedRoles: string[] = [];
}
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [NgScrollbarModule,RouterModule,CommonModule]
})
export class SidebarComponent {
  //#region Variables Declaration
  public menuAssist: MenuAssist = new MenuAssist();
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  public userModules: { [key: string]: { read: boolean } } = {};
  public role_name: string = ''
  public current_href: string = "";
  public selected_route: string = "";
  public isMenuFixed: boolean = true;

  public controlSystem: SidebarItem[] = [
    new SidebarItem(1, 'SADIN Control Board', '', 'appliance/control-board/control', [], null, false, 'Control'),
    new SidebarItem(2, 'Third-party Control Board', '', 'appliance/control-board/third-party', [], null, false, 'Control'),
    new SidebarItem(4, '2D Floor Plan', '', 'appliance/control-board/floor-plan', [], null, false, 'Control'),
  ];

  public scheduleManagement: SidebarItem[] = [
    new SidebarItem(1, 'Schedule List', '', 'schedule-management/schedule-list', [], null, false, 'Schedule'),
    new SidebarItem(2, 'Schedule Overview', '', 'schedule-management/schedule-overview', [], null, false, 'Schedule'),
  ];

  public energy: SidebarItem[] = [
    new SidebarItem(1, 'Overview', '', 'energy/overview', [], null, false, 'Energy'),
    new SidebarItem(2, 'Administrative Dashboard', '', 'energy/administrative-dashboard', [], null, false, 'EnergyAdmin'),
    new SidebarItem(3, 'Energy Report', '', 'energy/energy-report', [], null, false, 'Energy'),
    new SidebarItem(4, 'Consumption Report', '', 'energy/consumption-report', [], null, false, 'EnergyAdmin'),
    // new SidebarItem(4, 'Consumption Breakdown', '', 'energy/consumption-breakdown', [], null, false, 'Energy'),),
    new SidebarItem(5, 'Units Energy Usage', '', 'energy/units-energy-usage', [], null, false, 'Energy'),
  ];
  public water: SidebarItem[] = [
    new SidebarItem(1, 'Overview', '', 'water/overview', [], null, false, 'Water'),
    new SidebarItem(2, 'Water Report', '', 'water/water-report', [], null, false, 'Water'),
    new SidebarItem(3, 'Consumption Breakdown', '', 'water/consumption-breakdown', [], null, false, 'Water'),
    new SidebarItem(4, 'Units Water Usage', '', 'water/units-water-usage', [], null, false, 'Water'),
  ];
  public solarManagement: SidebarItem[] = [
    new SidebarItem(1, 'Overview', '', 'solar-management/overview'),
    new SidebarItem(2, 'Solar Panels', '', 'solar-management/solar-panels'),
    new SidebarItem(3, 'Reports', '', 'solar-management/reports'),
  ];
  public mosqueManagement: SidebarItem[] = [
    new SidebarItem(1, 'Overview', '', 'mosque-management/overview', [], null, false, 'Mosque'),
    new SidebarItem(2, 'Prayer Overview', '', 'mosque-management/prayer-overview', [], null, false, 'Mosque'),
    new SidebarItem(3, 'Prayer Time', '', 'mosque-management/prayer-time', [], null, false, 'Mosque'),
  ];
  public environment: SidebarItem[] = [
    new SidebarItem(1, 'Overview', '', 'environment/overview',[], null, false, 'Environment'),
    new SidebarItem(2, 'Indoor ENV Analysis', '', 'environment/indoor-env-analysis', [], null, false, 'Environment'),
    new SidebarItem(3, 'Consumption Breakdown', '', 'environment/consumption-env-breakdown', [], null, false, 'Environment'),
  ];
  public fireAlarmSystem: SidebarItem[] = [
    new SidebarItem(1, 'System Health', '', 'fire-alarm/system-health', [], null, false, 'Fire'),
    new SidebarItem(2, 'Maintenance Schedule', '', 'fire-alarm/maintenance-schedule', [], null, false, 'Fire'),
    new SidebarItem(3, 'Errors & Warning logs', '', 'fire-alarm/errors-warning-logs', [], null, false, 'Fire'),
  ];
  public hvac: SidebarItem[] = [
    new SidebarItem(1, 'System Health', '', 'hvac/system-health', [], null, false, 'HVAC'),
    new SidebarItem(2, 'Maintenance Schedule', '', 'hvac/maintenance-schedule', [], null, false, 'HVAC'),
    new SidebarItem(3, 'Errors & Warning logs', '', 'hvac/errors-warning-logs', [], null, false, 'HVAC'),
  ];
  public liftsSystem: SidebarItem[] = [
    new SidebarItem(1, 'System Health', '', 'lift-system/system-health', [], null, false, 'Lift'),
    new SidebarItem(2, 'Maintenance Schedule', '', 'lift-system/maintenance-schedule', [], null, false, 'Lift'),
    new SidebarItem(3, 'Errors & Warning logs', '', 'lift-system/errors-warning-logs', [], null, false, 'Lift'),
  ];
  public accessControlSystem: SidebarItem[] = [
    new SidebarItem(1, 'System Health', '', 'access-control/system-health', [], null, false, 'Access'),
    new SidebarItem(2, 'AI Detection', '', 'access-control/ai-detection', [], null, false, 'Access'),
    new SidebarItem(3, 'Live Monitoring (Live CCTV Feed)', '', 'access-control/live-monitoring-cctv', [], null, false, 'Access'),
    new SidebarItem(4, 'Live Monitoring (People Counting)', '', 'access-control/live-monitoring-people', [], null, false, 'Access'),
    new SidebarItem(5, 'ACS Management', '', 'access-control/acs-management', [], null, false, 'Access'),
    new SidebarItem(6, 'Entry Log', '', 'access-control/error-logs', [], null, false, 'Access'),
  ];
  public occupancy: SidebarItem[] = [
    new SidebarItem(1, 'Live Monitoring', '', 'occupancy/live-monitoring', [], null, false, 'Occupancy'),
    new SidebarItem(2, 'Occupancy by Zone', '', 'occupancy/by-zone', [], null, false, 'Occupancy'),
    new SidebarItem(3, 'Zone management', '', 'occupancy/zone-management', [], null, false, 'Occupancy'),
  ];
  public parking: SidebarItem[] = [
    new SidebarItem(1, 'System Health', '', 'parking/system-health', [], null, false, 'Parking'),
    new SidebarItem(2, 'Vehicle Management', '', 'parking/vehicle-management', [], null, false, 'Parking'),
    new SidebarItem(3, 'Vehicle Category', '', 'parking/vehicle-category', [], null, false, 'Parking'),
    new SidebarItem(4, 'Parking map', '', 'parking/parking-map', [], null, false, 'Parking'),
    new SidebarItem(5, 'Access Report', '', 'parking/access-report', [], null, false, 'Parking'),
  ];
  public assetManagement: SidebarItem[] = [
    new SidebarItem(1, 'Facility', '', 'asset/facility', [], null, false, 'Assets', ['owner', 'SADIN-ADMIN']),
    new SidebarItem(3, 'Units', '', 'asset/units', [], null, false, 'Assets'),
    new SidebarItem(2, 'Unit Type', '', 'asset/unit-type', [], null, false, 'Assets'),
  ];
  public networkManagement: SidebarItem[] = [
    new SidebarItem(1, 'Network Status', '', 'network/status', [], null, false, 'Network'),
    new SidebarItem(2, 'Network Configuration', '', 'network/configuration', [], null, false, 'Network'),
    new SidebarItem(3, 'Network logs', '', 'network/logs', [], null, false, 'Network'),
  ];
  public rolesAndPermissions: SidebarItem[] = [
    new SidebarItem(1, 'Roles', '', 'system-settings/role-permission/role'),
    new SidebarItem(2, 'Permission', '', 'system-settings/role-permission/permission'),
  ];
  public authentications: SidebarItem[] = [
    new SidebarItem(1, 'MFA', '', 'system-settings/authentication/mfa', [], null, false, 'Authentication'),
  ];
  public api: SidebarItem[] = [
    new SidebarItem(1, 'API Logs', '', 'system-settings/api/api-logs', [], null, false, 'API'),
    new SidebarItem(2, 'API Usage', '', 'system-settings/api/api-usage', [], null, false, 'API'),
  ];
  public appliances: SidebarItem[] = [
    new SidebarItem(1, 'Appliances List', '', 'system-settings/appliances', [], null, false, 'Appliances'),
    new SidebarItem(2, 'Appliances Categories', '', 'system-settings/appliance-category', [], null, false, 'Appliances'),
  ];
  public deviceManagement: SidebarItem[] = [
    new SidebarItem(1, 'Devices List', '', 'system-settings/device/devices-list', [], null, false, 'Device'),
    new SidebarItem(2, 'Device Categories', '', 'system-settings/device/device-categories', [], null, false, 'Device'),
    new SidebarItem(3, 'Device Types', '', 'system-settings/device/device-types', [], null, false, 'Device'),
    new SidebarItem(4, 'Auto / Manual Status', '', 'system-settings/device/auto-manual-status', [], null, false, 'Device'),
    new SidebarItem(5, 'Syslog', '', 'system-settings/device/syslog', [], null, false, 'Device'),
    new SidebarItem(6, 'Connection Log', '', 'system-settings/device/connection-log', [
      new SidebarItem(1, 'MQTT Log', '', 'system-settings/device/connection-log/mqtt-log', [], null, false, 'Device'),
      new SidebarItem(2, 'SRTP Log', '', 'system-settings/device/connection-log/srtp-log', [], null, false, 'Device'),
    ], null, false, 'Device'),
  ];
  public user: SidebarItem[] = [
    new SidebarItem(1, 'Users List', '', 'system-settings/users', [], null, false, 'User'),
    new SidebarItem(2, 'Roles & Permissions', '', 'system-settings/role-permission', [], null, false, 'User'),
    new SidebarItem(3, 'Authentications', '', 'system-settings/authentication', [], null, false, 'User'),
    new SidebarItem(4, 'Contacts', '', 'system-settings/contacts', [], null, false, 'User'),
    new SidebarItem(5, 'User Log', '', 'system-settings/activity-logs', [], null, false, 'Logs'),
  ]
  public adminSettings: SidebarItem[] = [
    new SidebarItem(0, 'Firmware Settings', '', 'system-settings/firmware', [], null, false, 'SystemAdmin'),
    new SidebarItem(1, 'MQTT Auth Settings', '', 'system-settings/mqttauth', [], null, false, 'SystemAdmin'),
    new SidebarItem(2, 'Dropdown Settings', '', 'system-settings/dropdown-settings', [], null, false, 'SystemAdmin'),
  ]
  public alarmsAndNotifications: SidebarItem[] = [
    new SidebarItem(1, 'Alarms', '', 'alarms/dashboard', [], null, false, 'SystemAdmin'),
    new SidebarItem(2, 'Alarm Acknowledgement', '', 'alarms/acknowledgement', [], null, false, 'SystemAdmin'),
    new SidebarItem(3, 'Alarm Incidents', '', 'alarms/incidents', [], null, false, 'SystemAdmin'),
    new SidebarItem(4, 'Alarm Logs', '', 'alarms/logs', [], null, false, 'SystemAdmin'),
    new SidebarItem(5, 'Notifications', '', 'alarms/notifications', [], null, false, 'SystemAdmin'),
  ];
  public systemSettings: SidebarItem[] = [
    new SidebarItem(0, 'Admin settings', '', 'system-settings/admin-settings', this.adminSettings , null, false, 'SystemAdmin'),
    new SidebarItem(1, 'Homepage Behavior', '', 'system-settings/homepage-behavior'),
    new SidebarItem(2, 'General Setting', '', 'system-settings/general'),
    new SidebarItem(3, 'Energy Setting', '', 'system-settings/energy', [], null, false, 'Energy'),
    new SidebarItem(5, 'Water Setting', '', 'system-settings/water', [], null, false, 'Water'),
    // new SidebarItem(6, 'User Setting', '', 'system-settings/users', this.user, null, null, 'User'),
    new SidebarItem(7, 'API', '', 'system-settings/api', this.api, null, null, 'API'),
    new SidebarItem(9, 'Appliances', '', 'system-settings/appliances', this.appliances, null, null, 'Appliances'),
    // new SidebarItem(10, 'Activity logs', '', 'system-settings/activity-logs', [], null, false, 'Logs'),
  ];
  public sidebarItems: SidebarItem[] = [
    new SidebarItem(0, 'Homepage', 'menu-icon fa-duotone fa-house', 'homepage'),
    new SidebarItem(1, 'Control Board', 'menu-icon fa-duotone fa-plug-circle-bolt text-mediumpurple','', this.controlSystem ,null,null,'Control',),
    new SidebarItem(2, 'Schedule Management', 'menu-icon fa-duotone fa-calendar-days text-info', '', this.scheduleManagement, null, null, 'Schedule'),
    new SidebarItem(2, 'Energy Management', 'menu-icon fa-duotone fa-square-bolt text-warning', '', this.energy, null, null, 'Energy'),
    new SidebarItem(3, 'Solar Management', 'menu-icon fa-duotone fa-solar-panel', '', this.solarManagement, '#f97316'),
    new SidebarItem(3, 'Water Management', 'menu-icon fa-duotone fa-droplet text-info', '', this.water, null, null, 'Water'),
    new SidebarItem(4, 'Environment', 'menu-icon fa-duotone fa-seedling text-success', '', this.environment, null, null, 'Environment'),
    new SidebarItem(5, 'Fire Alarm System', 'menu-icon fa-duotone fa-fire text-danger', '', this.fireAlarmSystem, null, null, 'Fire'),
    new SidebarItem(6, 'HVAC', 'menu-icon fa-duotone fa-air-conditioner', '', this.hvac, null, null, 'HVAC'),
    new SidebarItem(7, 'Lifts System', 'menu-icon fa-duotone fa-elevator', '', this.liftsSystem , null, null, 'Lift'),
    new SidebarItem(8, 'Access Control System', 'menu-icon fa-duotone fa-universal-access', '', this.accessControlSystem, '#4caf50', null, 'Access'),
    new SidebarItem(9, 'Occupancy', 'menu-icon fa-duotone fa-people-group me-3', '', this.occupancy, null, null, 'Occupancy'),
    new SidebarItem(10, 'Parking Management', 'menu-icon fa-duotone fa-square-parking text-blue', '', this.parking, null, null, 'Parking'),
    new SidebarItem(11, 'Units Management', 'menu-icon fa-duotone fa-building-flag', '', this.assetManagement, '#ff9f43', null, 'Assets'),
    new SidebarItem(12, 'Network Management', 'menu-icon fa-duotone fa-ethernet', '', this.networkManagement, '#00917C', null, 'Network'),
    new SidebarItem(12, 'User Management', 'menu-icon fa-duotone fa-users-gear', '', this.user, null, null, 'User'),
    new SidebarItem(4, 'Alarms & Notifications', 'menu-icon fa-duotone fa-bell', 'alarms', this.alarmsAndNotifications, '#dc2626', false, 'Notifications'),
    new SidebarItem(14, 'Devices Management', 'menu-icon fa-duotone fa-microchip', '', this.deviceManagement, null, null, 'Device'),
    new SidebarItem(13, 'System Settings', 'menu-icon fa-duotone fa-gear', '', this.systemSettings),
  ];
  //#endregion

  //#region Constructor
  constructor(private _router: Router, private _activatedRoute: ActivatedRoute) {
    _router.events.subscribe((val) => {
      this.current_href = this._router.url;
      this.removeAllActiveStatus();
      this.setActiveStatus(this.current_href.replace('/app/', ''));
    });
  }
  //#endregion

  //#region Input & Output

  //#endregion

  //#region lifecycle hook Methods
  ngOnInit(): void {
    //NGRX
    const user = localStorage.getItem('currentUser');
    if (user) {
      const parsed = JSON.parse(user);
      this.role_name = parsed.role_name;
      this.userModules = parsed.module_permissions || {};
      if(!this.isSadinAdmin()){
        this.filterSidebarItems()
      }
    }
  }
  ngAfterViewInit(): void {
    this.setAll();
    this.menuAssist.update(); // Helpers.update();
    this.menuAssist.mainMenu.update(); // Helpers.mainMenu.update();
    // (window as any).templateCustomizer.update();
  }
  ngOnDestroy() {
    // this.ngUnsubscribe$.next();
    // this.ngUnsubscribe$.complete();
  }
  //#endregion

  //#region HTML Events
  public selectSidebarItem(item: SidebarItem, parent: SidebarItem = null, grandParent: SidebarItem = null): void {
    if (item.childItems.length > 0) {
      item.showChild = !item.showChild;
      return;
    }
    this.removeAllActiveStatus();
    item.isActive = true;
    if (parent) {
      parent.isActive = true;
    }
    if (grandParent) {
      grandParent.isActive = true;
    }
    let routes: string[] = [];
    this.addRoutes(item.route, routes);
    this._router.navigate(routes, { relativeTo: this._activatedRoute });
    this.selected_route = item.route;
  }
  public selectChildSidebarItem(item: SidebarItem, parentItem: SidebarItem): void {
    if (item.childItems.length > 0) {
      item.showChild = !item.showChild;
    }
    let routes: string[] = [];
    // this.addRoutes(parentItem.route, routes);
    this.addRoutes(item.route, routes);
    this._router.navigate(routes, { relativeTo: this._activatedRoute });
  }
  public setAll(): void {
    // Initialize menu
    //-----------------
    let templateName = document.documentElement.getAttribute('data-template')
    let isHorizontalLayout = false;
    if (document.getElementById('layout-menu')) {
      isHorizontalLayout = document.getElementById('layout-menu').classList.contains('menu-horizontal');
    }
    let layoutMenuEl = document.querySelectorAll('#layout-menu');
    layoutMenuEl.forEach((element) => {
      let menu = new Menu(element, {
        orientation: isHorizontalLayout ? 'horizontal' : 'vertical',
        closeChildren: isHorizontalLayout ? true : false,
        // ? This option only works with Horizontal menu
        showDropdownOnHover: true
        // showDropdownOnHover: localStorage.getItem('templateCustomizer-' + templateName + '--ShowDropdownOnHover') // If value(showDropdownOnHover) is set in local storage
        //   ? localStorage.getItem('templateCustomizer-' + templateName + '--ShowDropdownOnHover') === 'true' // Use the local storage value
        //   : (window as any).templateCustomizer !== undefined // If value is set in config.js
        //     ? (window as any).templateCustomizer.settings.defaultShowDropdownOnHover // Use the config.js value
        //     : true // Use this if you are not using the config.js and want to set value directly from here
      });
      // Change parameter to true if you want scroll animation
      this.menuAssist.scrollToActive((false)); // (window as any).Helpers.scrollToActive((false));
      this.menuAssist.mainMenu = menu; // (window as any).Helpers.mainMenu = menu;
    });

    // Initialize menu togglers and bind click on each
    let menuToggler = document.querySelectorAll('.layout-menu-toggle');
    menuToggler.forEach(item => {
      item.addEventListener('click', event => {
        event.preventDefault();
        this.menuAssist.toggleCollapsed();
        // Enable menu state with local storage support if enableMenuLocalStorage = true from config.js
        if (!this.menuAssist.isSmallScreen()) {
          try {
            localStorage.setItem(
              'templateCustomizer-' + templateName + '--LayoutCollapsed',
              String(this.menuAssist.isCollapsed())
            );
          } catch (e) { }
        }
      });
    });

    // Menu swipe gesture

    // Detect swipe gesture on the target element and call swipe In
    this.menuAssist.swipeIn('.drag-target', (e) => {
      this.menuAssist.setCollapsed(false);
    });

    // Detect swipe gesture on the target element and call swipe Out
    this.menuAssist.swipeOut('#layout-menu', (e) => {
      if (this.menuAssist.isSmallScreen()) this.menuAssist.setCollapsed(true);
    });

    // Display in main menu when menu scrolls
    let menuInnerContainer = document.getElementsByClassName('menu-inner'),
      menuInnerShadow: any = document.getElementsByClassName('menu-inner-shadow')[0];
    if (menuInnerContainer.length > 0 && menuInnerShadow) {
      menuInnerContainer[0].addEventListener('ps-scroll-y', function () {
        if (this.querySelector('.ps__thumb-y').offsetTop) {
          menuInnerShadow.style.display = 'block';
        } else {
          menuInnerShadow.style.display = 'none';
        }
      });
    }
  }
  private removeAllActiveStatus(): void {
    this.sidebarItems.forEach(item => {
      item.isActive = false;
      item.isOpen = false;
      item.childItems.forEach(child => {
        child.isActive = false;
        child.isOpen = false;
        child.childItems.forEach(secondChild => {
          secondChild.isActive = false;
          secondChild.isOpen = false;
        });
      });
    });
  }
  private setActiveStatus(current_route: string): void {
    let selectedFound: boolean = false;
    this.sidebarItems.forEach(item => {
      item.childItems.forEach(child => {
        child.childItems.forEach(secondChild => {
          secondChild.isActive = this.checkRouteMatch(current_route, secondChild.route);
          if (secondChild.isActive) {
            item.isActive = true;
            item.isOpen = true;
            child.isActive = true;
            child.isOpen = true;
            selectedFound = true;
          }
        });
      });
    });
    if (!selectedFound) {
      this.sidebarItems.forEach(item => {
        item.childItems.forEach(child => {
          child.isActive = this.checkRouteMatch(current_route, child.route);
          if (child.isActive) {
            item.isActive = true;
            item.isOpen = true;
            selectedFound = true;
          }
        });
      });
    }
    if (!selectedFound) {
      this.sidebarItems.forEach(item => {
        item.isActive = this.checkRouteMatch(current_route, item.route);
        if (item.isActive) {
          item.isOpen = true;
          selectedFound = true;
        }
      });
    }
  }
  private checkRouteMatch(current_route: string, menuRoute: string): boolean{
    if(menuRoute === '') return false;
    return (current_route.includes(menuRoute))  ? true : false;
  }


  private filterSidebarItems(): void {
  const hasAccess = (key: string): boolean => key ? this.userModules[key]?.read === true : true;
  const hasRoleAccess = (item: SidebarItem): boolean =>
    item.allowedRoles.length === 0 || item.allowedRoles.some(role => this.isRole(role));

  const filterItems = (items: SidebarItem[]): SidebarItem[] => {
    return items
      .map(item => {
        const filteredChildren = filterItems(item.childItems);
        const canShowSelf = item.allowedRoles.length > 0 ? hasRoleAccess(item) : hasAccess(item.moduleKey);
        const canShow = canShowSelf || filteredChildren.length > 0;
        return canShow
          ? new SidebarItem(
              item.id,
              item.label,
              item.icon,
              item.route,
              filteredChildren,
              item.iconColor,
              item.showChild,
              item.moduleKey,
              item.allowedRoles
            )
          : null;
      })
      .filter(Boolean) as SidebarItem[];
  };

  this.sidebarItems = filterItems(this.sidebarItems);
}

  private isSadinAdmin(): boolean {
    return this.isRole('SADIN-ADMIN');
  }

  private isRole(roleName: string): boolean {
    return this.role_name?.toLowerCase() === roleName.toLowerCase();
  }


  //#endregion

  //#region Api Methods

  //#endregion

  //#region Private Methods
  private addRoutes(route: string | null, routes: string[]) {
    if (route) {
      routes.push(route);
    }
  }
  //#endregion
}
